import React, {useState} from "react";
import {DefaultButton, IContextualMenuProps} from "@fluentui/react";
import {
    useAddSavedSearchToProductBundleMutation,
    useGetTopProductBundleRefsQuery
} from "../../store/endpoints/ProductBundleEndpoints";

interface IAddSavedSearchToBundleButtonProps {
    // The saved search must already be saved (have an id) to be added to a bundle.
    savedSearchId?: string;
}

/**
 * Footer button on the Saved Search panel that adds the (already-saved) saved search to a product
 * bundle as its single saved-search item. Mirrors the bundle menu on AddToCollectionButton, but keyed
 * on the saved search rather than a product.
 */
const AddSavedSearchToBundleButton: React.FC<IAddSavedSearchToBundleButtonProps> = (props) => {
    const [showStatus, setShowStatus] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const getTopBundles = useGetTopProductBundleRefsQuery({});
    const [addSavedSearchToBundle] = useAddSavedSearchToProductBundleMutation();

    const flashStatus = (success: boolean) => {
        setUpdateSuccess(success);
        setShowStatus(true);
        setTimeout(() => setShowStatus(false), 5000);
    };

    const menuProps: IContextualMenuProps = {
        items: (getTopBundles.data?.items ?? []).map(bundle => ({
            key: bundle.id ?? '',
            text: `Add to ${bundle.name} bundle`,
            onClick: () => {
                if (bundle.id && props.savedSearchId) {
                    addSavedSearchToBundle({bundleId: bundle.id, savedSearchId: props.savedSearchId})
                        .unwrap()
                        .then(result => flashStatus(result.success === true))
                        .catch(() => flashStatus(false));
                }
            }
        }))
    };

    return (
        <div style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}>
            <DefaultButton
                text='Add to'
                menuProps={menuProps}
                iconProps={{iconName: 'Add'}}
                disabled={!props.savedSearchId || getTopBundles.isFetching || getTopBundles.isLoading || (getTopBundles.data?.items?.length ?? 0) === 0}
                title={!props.savedSearchId ? 'Save the search before adding it to a bundle' : undefined}
            />
            {showStatus && (updateSuccess
                ? <span style={{color: '#107c10', fontSize: '0.9em'}}>&#10003; Added!</span>
                : <span style={{color: '#cb4040', fontSize: '0.9em'}}>x Failed to Add</span>)}
        </div>
    );
};

export default AddSavedSearchToBundleButton;
